import React from "react";
import { useEffect, useState, Fragment } from "react";
import { useParams, Link } from "react-router-dom";
import { createMarkup } from "../../helpers";
import { useDispatch, useSelector } from "react-redux";
import { feeddataActions } from "../actions";
import { useCookies } from "react-cookie";
const ContentCookie = () => {
    const dispatch = useDispatch();
    const { typecookie } = useParams();
    const feedData = useSelector((state) => state.feedData);
    const [policy, setpolicy] = useState([]);
    const [cookiePolicy, setcookiePolicy] = useState([]);
    const [cookies, setCookie, removeCookie] = useCookies(["acceptCookie"]);
    useEffect(() => {
        $("#PolicyCookies").hide();
        async function feedData() {
            await dispatch(feeddataActions.feedData(`/api/info/home`));
        }
        feedData();
    }, []);

    useEffect(() => {
        if (feedData.fetchSuccess) {
            console.log(feedData.data.privacy_policy);
            if (
                feedData.data.privacy_policy &&
                feedData.data.privacy_policy.length
            ) {
                setpolicy(feedData.data.privacy_policy[1]);
                setcookiePolicy(feedData.data.privacy_policy[0]);
            }
        }
    }, [feedData.fetchSuccess]);

    return (
        <Fragment>
            <div className="bg-gray-50 py-2 intro-y max-h-screen">
                <div className="max-w-screen-xl mx-auto shadow-xl mt-14 border-b-2 border-x-2 border-gray-200 rounded-md px-6 py-8 intro-y">
                    <div className="lg:w-4/6 w-full px-1 text-left">
                        <h2 className="intro-x">
                            <a
                                href={`/`}
                                target="_self"
                                className=" hover:text-custom-700 text-gray-800 text-base"
                            >
                                <i className="fa fa-reply"></i>
                                &nbsp; กลับหน้าหลัก
                            </a>
                            {/* {console.log(policy)} */}
                        </h2>
                    </div>
                    {typecookie == "cookies" ? (
                        <p
                            className="my-4 intro-y"
                            dangerouslySetInnerHTML={createMarkup(
                                cookiePolicy.Note
                            )}
                        />
                    ) : (
                        <p
                            className="my-4 intro-y break-words text-sm md:text-base"
                            dangerouslySetInnerHTML={createMarkup(policy.Note)}
                        />
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default ContentCookie;
